import styled from 'styled-components'

type StyledProps = {
  $inPlatform?: boolean
}

const StyledAppLayout = styled.div<StyledProps>`
  ${({ $inPlatform }) => $inPlatform && 'padding: 0 0 80px 0;'}
  ${({ $inPlatform }) => !$inPlatform && 'padding: 70px 0 80px 0;'}

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    padding: 70px 0 0 0;
  }
`

export default StyledAppLayout
